import clsx from 'clsx';
import type { ItemNav } from '../dados/navegacao';

type NavLinksProps = {
  itens: readonly ItemNav[];
  ativo: string | null;
  className?: string;
  aoClicarLink?: () => void;
};

/** Lista de links de âncora com o item ativo destacado pelo scrollspy. */
export function NavLinks({ itens, ativo, className, aoClicarLink }: NavLinksProps) {
  return (
    <ul className={clsx('flex', className)}>
      {itens.map((item) => (
        <li key={item.id}>
          <a
            href={`#${item.id}`}
            onClick={aoClicarLink}
            aria-current={ativo === item.id ? 'true' : undefined}
            className={clsx(
              'block px-1 py-1 text-sm font-normal transition-colors duration-150',
              ativo === item.id
                ? 'text-auth-texto'
                : 'text-auth-texto-secundario hover:text-auth-texto',
            )}
          >
            {item.rotulo}
          </a>
        </li>
      ))}
    </ul>
  );
}
